import { createAsyncThunk } from '@reduxjs/toolkit';

import BorrowerApi from 'prequalificationV2/api/BorrowersApi';

export const getBorrowerByTokenThunk = (borrowerApi: BorrowerApi) =>
  createAsyncThunk('borrower/getBorrowerByToken', async () => {
    return await borrowerApi.getBorrowerByToken();
  });
